import request from '@/utils/request.js';

export const checkLoginStatusService = () => {
  return request('/user/check');
};
